import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full sm:w-2/3 grid grid-cols-1 gap-x3 mb-x5" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "c-magic-line c-magic-line--underline whitespace-nowrap text-dusty-grey" }

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useOutletProductDetailData from '@/shared/product/details/ui/outlet/useOutletProductDetailData';
import PDPLink from '@/shared/navigation/PDPLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OutletProductProperties',
  setup(__props) {

const { outletProductData: productData } = useOutletProductDetailData();
const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dl", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productData).customizerTabModels, (property) => {
        return (_openBlock(), _createElementBlock("div", {
          key: property.id,
          class: "grid grid-cols-2"
        }, [
          _createElementVNode("dt", _hoisted_2, _toDisplayString(property.title), 1),
          _createElementVNode("dd", null, _toDisplayString(property.description), 1)
        ]))
      }), 128))
    ]),
    (_unref(productData).showLinkToProductPage)
      ? (_openBlock(), _createBlock(PDPLink, {
          key: 0,
          title: _unref(labels).customizeFromNew,
          sku: _unref(productData).originalSku
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(labels).customizeFromNew), 1),
            _createTextVNode(),
            _createVNode(_component_c_icon, {
              "aria-hidden": "true",
              name: "icon-arrow-small",
              class: "w-8 ml-x1 text-dusty-grey"
            })
          ]),
          _: 1
        }, 8, ["title", "sku"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})